import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Formatters} from 'angular-slickgrid';

@Component({
    selector: 'app-client-func',
    templateUrl: './client-func.component.html',
    styleUrls: ['./client-func.component.css']
})
export class ClientFuncComponent implements OnInit, OnDestroy {

    clientName: string;
    description: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;
    urlSelected: number;
    urlArr = [];
    url: string;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private adminAuth: Subscription;

    private notifier: NotifierService;
    offset: number;
    urlKey: string;
    clients = [];
    clientSelected: number;
    fieldValues = [];
    fieldSelected: number;
    fields = [];
    fieldName: string;
    fieldValueSelected: number;

    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                        }
                    }
                    break;
                case 'delete':
                    console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteClientSpecificUrl({user_id: this.messageService.getUserId(), id: item.id}).subscribe((res) => {
                                this.respObject = res;
                                // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.notifier.notify('success', 'URL Deleted successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
    }

    ngOnInit() {
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Ticket Menu Mapping',
            openModalButton: 'Map Ticket Menu',
            breadcrumb: 'Ticket Menu Mapping',
            tabName: 'Ticket Menu Mapping'
        };

        this._rest.getAdditionalFunc().subscribe((res1) => {
            this.respObject = res1;
            // console.log(JSON.stringify(res1));
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Additional Field'});
                this.fields = this.respObject.details;
                this.fieldSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {

        });

        this._rest.getClient().subscribe((res) => {
            this.respObject = res;
            // console.log(JSON.stringify(this.respObject.clients));
            if (this.respObject.success) {
                this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                this.clients = this.respObject.clients;
                this.clientSelected = 0;
            } else {

            }
        }, function (err) {

        });
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'client', name: 'client Name', field: 'client', sortable: true, filterable: true
            }, {
                id: 'funcType', name: 'Type', field: 'type', sortable: true, filterable: true
            }, {
                id: 'name', name: 'Name', field: 'name', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
    }

    onPageLoad() {
        this.getTableData();
    }

    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.fieldSelected = 0;
            // this.url = '';
            this.modalService.open(content, {}).result.then((result) => {
            }, (reason) => {

            });
        }

    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    get selectedFieldValue() {
        return this.fieldValues
            .filter(opt => opt.checked)
            .map(opt => opt);

    }

    save() {
        const data = {
            clientId: this.clientSelected,
            funcId: this.fieldSelected,
            value: this.selectedFieldValue,
            createdBy: this.messageService.getUserId()
        };
        console.log(JSON.stringify(data));
        if (!this.messageService.isBlankField(data) && this.selectedFieldValue.length) {
            this._rest.mapClientWiseFunctionality(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    this.isError = false;
                    // const id = this.respObject.details;
                    // this.messageService.setRow({id: id, client_name: this.clientName, url_key: this.urlKey, url: this.url});
                    // if (this.totalData <= this.pageSize * this.page_no) {
                    //     this.offset = id;
                    //     this.nextOffset = 0;
                    // } else {
                    //     this.nextOffset = this.offset;
                    // }
                    this.clientSelected = 0;
                    this.fieldSelected = 0;
                    // this.url = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }

    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }


    onClientChange(value: any) {
        this.clientName = this.clients[value].name;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this._rest.getFunctionalityDetails(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }

    onFieldChange(selectedIndex: any) {
        this.fieldName = this.fields[selectedIndex].name;
        this._rest.getFunctionalityByClient(this.clientId, this.fieldSelected, this.clientSelected).subscribe((res1) => {
            this.respObject = res1;
            // console.log(JSON.stringify(res1));
            if (this.respObject.success) {
                this.isError = false;
                // this.respObject.details.unshift({id: 0, name: 'Select Field Value'});
                this.fieldValues = this.respObject.details;
                this.fieldValueSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }
}
